import APIService from '@/services/APIService.js';

export default {
  getRelatorio() {
    return APIService.apiCall().get('/armazenamento/tabelas-x-disco');
  }
};
